import { useQuery } from "@tanstack/react-query";
import { useMerchant } from "@/hooks/useMerchant";
import { useProtectTRPC } from "../trpc";

export function useFetchScreening(id?: string) {
  const { merchant } = useMerchant();
  const trpc = useProtectTRPC();

  const { data, isPending, isError } = useQuery({
    ...trpc.screenings.get.queryOptions({
      rentalsMerchantId: merchant?.id ?? "",
      id: id ?? "",
    }),
    enabled: !!merchant?.id && !!id,
  });

  return { screening: data, isLoading: isPending, isError };
}
